import { useCallback, useContext } from "react";
import Notice from "./Notice";
import NoticesContext from "@jnctn-app/contexts/NoticesContext";
import useDismissableAutohider from "@jnctn/hooks/useDismissableAutohider";
import StandardButton from "@jnctn/design-system/Button/StandardButton.component";
import { ReactComponent as CloseIcon } from "@jnctn/icons/close.svg";
import { ReactComponent as DownloadIcon } from "@jnctn/icons/download.svg";
import Text from "@jnctn/design-system/Text/Text.component";
import Button from "@jnctn/design-system/Button/Button.component";

const INSTALLABLE_DISMISS_DELAY = 30 * 1000;

export default function InstallableNotice() {
  const { installable, setInstallable, addToHomeScreen } = useContext(
    NoticesContext
  );
  const setNotInstallable = useCallback(() => setInstallable(false), [
    setInstallable,
  ]);
  const [installableHide] = useDismissableAutohider(
    installable,
    setNotInstallable,
    INSTALLABLE_DISMISS_DELAY,
    30
  );

  if (installable) {
    return (
      <Notice
        text="JNCTN can be installed"
        icon={
          <Text color="white" size="body1">
            <DownloadIcon className="w-10 h-10" />
          </Text>
        }
        actions={[
          <StandardButton
            label="Install"
            onClick={addToHomeScreen}
            size="small"
          />,
          <Button
            label="dismiss"
            onClick={installableHide}
            labelHidden={true}
            icon={
              <Text color="white" size="body1">
                <CloseIcon className="w-8 h-8" />
              </Text>
            }
          />,
        ]}
      />
    );
  }

  return null;
}
